import _ from 'lodash';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Uchain } from '../redux/api/agent';
import { sagaActions } from './sagaActions';
import { clearCommodityList, clearError, getCommodityFailure, getCommoditySuccess, initiateCommodityLoading } from '../redux/reducers/reducerSlices/CommodityReducer';

function* commodityListByWarehouseIdSaga(data) {
    try {
        yield put(initiateCommodityLoading(true))
        const response = yield call(Uchain.getCommodityByWarehouseId, data.payload);
        yield put(getCommoditySuccess(response));
    } catch {
        yield put(getCommodityFailure());
    }finally{
                yield put(initiateCommodityLoading(false))
    }
}

function* clearCommodityListSaga() {
    try {
        yield put(clearCommodityList());
    } catch { }
}

function* clearCommodityErrorSaga() {
    try {
        yield put(clearError());
    } catch { }
}

export function* getCommodityListByWarehouseIdWatcher() {
    yield takeEvery(sagaActions.COMMODITY_LIST_BY_WAREHOUES_ID, commodityListByWarehouseIdSaga)
}

export function* clearCommodityListWatcher() {
    yield takeEvery(sagaActions.CLEAR_COMMODITY, clearCommodityListSaga)
}

export function* clearCommodityErrorWatcher() {
    yield takeEvery(sagaActions.CLEAR_COMMODITY_ERROR, clearCommodityErrorSaga)
}

